import React, { useEffect } from 'react';
import ListIcon from '@mui/icons-material/ListOutlined';
import ArticleIcon from '@mui/icons-material/Article';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountIcon from '@mui/icons-material/AccountCircle';
import HomeIcon from '@mui/icons-material/HomeMaxOutlined'
import AlignHorizontalLeftIcon from '@mui/icons-material/AlignHorizontalLeft';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'
import FlightLandIcon from '@mui/icons-material/FlightLand'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import BellIcon from '@mui/icons-material/NotificationImportant';
import CalendarIcon from '@mui/icons-material/CalendarToday';
import PolicyOutlined from '@mui/icons-material/PolicyOutlined';
import WorkIcon from '@mui/icons-material/Work';
import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
 import LocalAirportIcon from '@mui/icons-material/LocalAirport';

import Access from './authorize';
const links = [
    { icon: <HomeIcon />, text: 'Dashboard', link: '/' },
    { icon: <AccountIcon />, text: 'Tenants', link: '/companies', secure: true, module: 'Company' },
    { icon: <FlightLandIcon />, text: 'Transient & Landing Fees', link: '/tiedown', secure: true, module: 'Tiedown' },
    { icon: <ListIcon />, text: 'Property Listings', link: '/properties/listings', secure: true, module: 'Property' },
    //{ icon: <ListIcon />, text: 'Property Listings', link: '/listings', external: true, module: 'Property' },
    { icon: <ArticleIcon />, text: 'Lease Agreements', link: '/agreements', module: 'Lease' },
    { icon: <AlignHorizontalLeftIcon />, text: 'WaitList', link: '/waitList', secure: true, module: 'Waitlist' },
    { icon: <MonetizationOnIcon />, text: 'Invoices', link: '/invoices', module: 'Invoices' },
    { icon: <MonetizationOnIcon />, text: 'Transactions', link: '/transactions', secure: true, module: 'Invoices' },
    { icon: <ManageAccountsIcon />, text: 'My Account', link: '/myaccount' },
    { icon: <ShowChartIcon />, text: 'Reports', link: '/interactive', secure: true, module: 'Reports' },
   /* { icon: <AutoAwesomeIcon />, text: 'AI Reports', link: '/ai-reporting', secure: true, module: 'Reports' },*/
    { icon: <BellIcon />, text: 'Communication', link: '/alerts', secure: true, module: 'Alerts' },
    { icon: <CalendarIcon />, text: 'Appointments', link: '/appointment', secure: true, module: 'Appointments' },
    { icon: <PolicyOutlined />, text: 'Inspections', secure: true, link: '/inspection', module: 'Inspections' },
    { icon: <WorkIcon />, text: 'Workorders', secure: true, link: '/workorder', module: 'Workorders' },
    { icon: <BubbleChartIcon />, text: 'Assets', secure: true, link: '/asset', module: 'Assets' },
    { icon: <AssessmentIcon />, text: 'Incident Reports', link: '/incident-reports', secure: true, module: 'IncidentReports' },
    { icon: <SettingsIcon />, text: 'Settings', link: '/settings', secure: true, module: 'Settings' },
  ]

export const getAvailable = () => {
    const result = links.filter(x => {
       if (x.secure) {
        //if (!Access.isAdmin('Settings'))  // Admin has access to all secure links
          return x.module ? Access.hasAccess(x.module) : false

      }
      // No module = visible to everyone
      return true
    })
    return result
  }
